import { LinearProgress as MUILinearProgress, LinearProgressProps } from '@mui/material'

import classes from './linear-progress.styles'

interface LinearProgressM3Props extends LinearProgressProps {
  selected?: boolean
  icon?: React.ReactNode
}

const LinearProgress = ({ ...props }: LinearProgressM3Props) => {
  return <MUILinearProgress {...props} sx={classes.linearProgress} />
}

export default LinearProgress
